import { ECountry } from '@/shared/enum/country.enum'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'
import getCountryFromPhoneCode from '@/shared/utils/get-country-from-phone-code'
import getDecodedToken from '@/shared/utils/get-decoded-token'
import getTokenFromUrl from '@/shared/utils/get-token-from-url'

const getCurrentCountry = (): ECountry => {
  const url = window.location.hostname

  const countries = [ECountry.GT, ECountry.CR, ECountry.HN, ECountry.NI, ECountry.SV]

  const fromUrl = countries.find(
    (country) => url.includes(`.${country}`) || url.includes(`${country}.`)
  )
  if (fromUrl) return fromUrl

  const token = getTokenFromUrl()
  if (token) {
    const payload = getDecodedToken(token)
    const msisdn = payload?.msisdn
    if (msisdn) {
      const fromPhone = getCountryFromPhoneCode(Number(msisdn.substring(0, 3)))
      if (fromPhone) return fromPhone
    }
  }

  const fromLS = localStorage.getItem(ELocalStorageKey.I18N)
  if (fromLS && fromLS.toUpperCase() in ECountry) {
    return ECountry[fromLS.toUpperCase() as keyof typeof ECountry]
  }

  return ECountry.GT
}

export default getCurrentCountry
